import { Component } from '@angular/core';

@Component({
  selector: 'app-investiments',
  templateUrl: './investiments.component.html',
  styleUrls: ['./investiments.component.scss'],
})
export class InvestimentsComponent {}
